import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@models/form/button';

@Component({
  templateUrl: './assign-retry-dialog.component.html',
  styleUrls: ['./assign-retry-dialog.component.scss'],
})
export class AssignRetryDialogComponent implements OnInit {
  header: string;
  studentName: string;
  message: string;

  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Send',
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public name: string,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.header = `Give ${this.name.trim()} another try!`;
    this.studentName = this.name.trim();
  }

  public submit(): void {
    this.dialogRef.close(this.message);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
